import React from 'react';
import { useCurrentSearchState } from 'controllers/SearchController/hooks/useCurrentSearchState';
import { useSearchController } from 'controllers/SearchController/SearchContext';
import useBuildQueryString from 'controllers/SearchController/hooks/useBuildQueryString';
import { ControllerQueryConfig } from 'controllers/SearchController/types';
import { TabNames } from 'types/enums';
import { useModalContext } from 'contexts/ModalContext/ModalContext';
import useAdvancedFilter from 'components/Filters/components/SearchTools/hooks/useAdvancedFilter';
import GenericSearchQuery from '../GenericSearchQuery/GenericSearchQuery';

const SearchQuery = ({
    samplesQueryConfig,
    packsQueryConfig,
}: {
    samplesQueryConfig: ControllerQueryConfig;
    packsQueryConfig?: ControllerQueryConfig;
}) => {
    const { page, tab } = useCurrentSearchState();
    const { isModalVisible } = useModalContext();
    const {
        packsPerPage,
        samplesPerPage,
        updateSamplesResult,
        updateSamplesLoading,
        updateSamplesError,
        updateSamplesCompleted,
        updateAllSamplesResult,
        updateAllSamplesLoading,
        updateAllSamplesError,
        updateAllSamplesCompleted,
        updatePacksResult,
        updatePacksLoading,
        updatePacksError,
        updatePacksCompleted,
        updateAllPacksResult,
        updateAllPacksLoading,
        updateAllPacksError,
        updateAllPacksCompleted,
    } = useSearchController();

    const queryString = useBuildQueryString();

    const { getIsAdvancedFiltersMobileOpen } = useAdvancedFilter();

    const isMobileFilterOpen = getIsAdvancedFiltersMobileOpen;

    const isSamplesQueryAllowed = !!samplesQueryConfig;
    const isQueryAllSamplesAllowed =
        isSamplesQueryAllowed ||
        isModalVisible.advancedFiltersModal ||
        isMobileFilterOpen;

    const isPacksQueryAllowed = !!packsQueryConfig;
    const isQueryAllPacksAllowed = isPacksQueryAllowed;

    return (
        <>
            {isSamplesQueryAllowed && samplesQueryConfig && (
                <GenericSearchQuery
                    queryConfig={samplesQueryConfig}
                    queryString={queryString}
                    page={tab !== TabNames.Samples ? 1 : page}
                    itemsPerPage={samplesPerPage}
                    updateResult={updateSamplesResult}
                    updateLoading={updateSamplesLoading}
                    updateError={updateSamplesError}
                    updateCompleted={updateSamplesCompleted}
                />
            )}
            {isQueryAllSamplesAllowed && samplesQueryConfig && (
                <GenericSearchQuery
                    queryConfig={samplesQueryConfig}
                    queryString=""
                    page={1}
                    itemsPerPage={1}
                    updateResult={updateAllSamplesResult}
                    updateLoading={updateAllSamplesLoading}
                    updateError={updateAllSamplesError}
                    updateCompleted={updateAllSamplesCompleted}
                />
            )}
            {isPacksQueryAllowed && (
                <GenericSearchQuery
                    queryConfig={packsQueryConfig}
                    queryString={queryString}
                    page={tab !== TabNames.Packs ? 1 : page}
                    itemsPerPage={packsPerPage}
                    updateResult={updatePacksResult}
                    updateLoading={updatePacksLoading}
                    updateError={updatePacksError}
                    updateCompleted={updatePacksCompleted}
                />
            )}
            {isQueryAllPacksAllowed && (
                <GenericSearchQuery
                    queryConfig={packsQueryConfig}
                    queryString=""
                    page={1}
                    itemsPerPage={1}
                    updateResult={updateAllPacksResult}
                    updateLoading={updateAllPacksLoading}
                    updateError={updateAllPacksError}
                    updateCompleted={updateAllPacksCompleted}
                />
            )}
        </>
    );
};

export default SearchQuery;
